var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{fill:#020000;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.0194 128)",
    className: "st0",
    cx: 128,
    cy: 128,
    rx: 119,
    ry: 119
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.9,100.3c0-5.8,4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5c0,5.8-4.7,10.5-10.5,10.5S63.9,106.1,63.9,100.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.1,100.3c0-5.8,4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5c0,5.8-4.7,10.5-10.5,10.5S171.1,106.1,171.1,100.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192,147.9c-8.5,27.3-33.9,47.1-64,47.1c-30.1,0-55.5-19.8-64-47.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 69.1,
    y1: 145,
    x2: 56.9,
    y2: 150.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 186.9,
    y1: 145,
    x2: 199.1,
    y2: 150.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalm);
export default __webpack_public_path__ + "static/media/Calm.16965589052fe3e8ed6e822a76150cdb.svg";
export { ForwardRef as ReactComponent };